"use client";

import { Suspense, useEffect } from "react";

import { useVariantState } from "@/stf.m.product/feat.product-detail";

import { type ServerDataOutput } from "../data.subscription-data";

interface ApplyDefaultOptsWithParamsProps {
  data: ServerDataOutput;
}
export const ApplyDefaultOptsWithParams = (props: ApplyDefaultOptsWithParamsProps) => {
  const { data } = props;

  const {
    subscriptionData: {
      subscriptionMeta: {
        defaultOption,
      },
    },
  } = data;
  const { setOpts, opts } = useVariantState();

  useEffect(() => {
    if (!opts) {
      setOpts(defaultOption);
    }
  }, [opts]);

  return <></>;
};

interface ApplyDefaultOptsProps {
  data: ServerDataOutput;
}
export const ApplyDefaultOpts = (props: ApplyDefaultOptsProps) => {
  const { data } = props;

  return (
    <Suspense>
      <ApplyDefaultOptsWithParams data={data} />
    </Suspense>
  );
};
